import { Stack, Box, Grid } from '@mui/material';
import CurrencySelector from 'components/activity-display/control-header/CurrencySelector';
import PaxQtySelector from 'components/activity-display/control-header/PaxQtySelector';
import CartButton from 'components/activity-display/control-header/CartButton';
import HeaderThemeProvider from 'components/themes/HeaderTheme';
import { useUI } from 'hooks/useUI';

function ControlHeader() {
	const { isSizeOrLess } = useUI();

	const isXsApp = isSizeOrLess('xs');

	return(
		<>
			<HeaderThemeProvider>
				<div style={{ padding: '14px 5px 12px 5px' }}>
					<Grid
						container
						spacing={2}
						sx={{ width: '100%' }}
						alignItems="center"
						justifyContent="center"
					>
						<Grid item xs>
							<Box display="flex" alignItems="center" justifyContent="center">
								<PaxQtySelector />
							</Box>
						</Grid>
						<Grid item xs>
							<Box display="flex" alignItems="center" justifyContent="center">
								<CurrencySelector />
							</Box>
						</Grid>
						<Grid item xs>
							<Box display="flex" alignItems="center" justifyContent="center">
								<CartButton />
							</Box>
						</Grid>
					</Grid>
				</div>
			</HeaderThemeProvider>
		</>
	);
}

export default ControlHeader;